export const API_ENDPOINTS = {
  subscribe: '/customers',
  getCountries: '/countries',
  getShippingRate: '/shippingProfiles',
} as const;
